<div class="SLV2-bookmark-card">
    <div class="SLV2-bookmark-thumb">
        <img src="selflearnv2-ui/assets/img/selflearn-v2-thumb.jpg" />
        <span class="SLV2-bookmark-time-tag">09:30</span>
    </div>
    <div class="SLV2-bookmark-content-area">
        <div class="SLV2-bookmark-info-row">
            <div class="SLV2-bookmark-info">
                <img src="selflearnv2-ui/assets/img/eye-icon-2.svg" /><span>550 views</span>
            </div>
        </div>
        <h4 class="SLV2-bookmark-title">The Last Star in the Universe - Red Dwarfs Explained.</h4>
    </div>

</div>
<div class="SLV2-bookmark-card" *ngIf="false">
    <div class="SLV2-bookmark-thumb">
        <img src="selflearnv2-ui/assets/img/selflearn-v2-thumb.jpg" />
        <span class="SLV2-bookmark-time-tag">09:30</span>
    </div>
    <div class="SLV2-bookmark-content-area">
        <div class="SLV2-bookmark-info-row">
            <div class="SLV2-bookmark-info">
                <img src="selflearnv2-ui/assets/img/eye-icon-2.svg" /><span>550 views</span>
            </div>
        </div>
        <h4 class="SLV2-bookmark-title">The Last Star in the Universe - Red Dwarfs Explained.</h4>
    </div>

</div>
